/**
 * padHost — мелочи полей-хостов кастомных падов формы брони (06.09, владелец:
 * «клик в поле ввода вызывает кроме кастомной клавиатуры стандартную»).
 * «Одна клавиатура за раз» живёт в shared/padFocus (blurOtherField — перед
 * открытием любого пада фокус и клавиатура ОС уходят из чужого поля); здесь —
 * только то, что нужно самой форме: снять каретку с комментария при закрытии
 * его docked-пада и докрутить поле комментария над docked-клавиатурой.
 */
export { blurOtherField as blurSystemField } from "../shared/padFocus";

/**
 * Снять фокус ТОЛЬКО с указанного поля-хоста (после закрытия его docked-пада):
 * если фокус уже ушёл в другое поле (например, «имя» — так пад и закрылся),
 * его не трогаем — иначе спрятали бы только что поднятую клавиатуру ОС.
 */
export function blurIfActive(el: HTMLElement | null | undefined): void {
  if (el && document.activeElement === el) el.blur();
}

/** Запас между низом поля и docked-клавиатурой; высота панели по умолчанию, пока не измерена. */
const GAP = 12;
const DOCK_H_DEFAULT = 340;

/**
 * Поле комментария видно над docked-клавиатурой (02.09). 06.09 (владелец):
 * внутренний скролл поля — к концу текста ТОЛЬКО если каретка в конце (или поле
 * не в фокусе): правка в середине длинного комментария не уводит каретку из
 * вида. Скроллер модалки докручивается, только если поле ушло под клавиатуру
 * или за верх экрана — иначе не дёргаем.
 */
export function scrollCommentAboveDock(el: HTMLTextAreaElement, dockH: number): void {
  const s = el.selectionStart;
  const atEnd = document.activeElement !== el || typeof s !== "number" || s >= el.value.length;
  if (atEnd) el.scrollTop = el.scrollHeight;
  let sc: HTMLElement | null = el.parentElement;
  while (sc && !/(auto|scroll)/.test(getComputedStyle(sc).overflowY)) sc = sc.parentElement;
  /* 26.09 (владелец: «при заполнении комментария перекрывается поле ввода»): между скроллером
     и клавиатурой может стоять футер шита с кнопкой — поле обязано быть видно и в самом
     скроллере, а не только над клавиатурой. */
  const box = sc?.getBoundingClientRect();
  const limit = Math.min(window.innerHeight - (dockH || DOCK_H_DEFAULT), box ? box.bottom : Infinity) - GAP;
  const top = box ? Math.max(0, box.top) : 0;
  const r = el.getBoundingClientRect();
  if (r.bottom <= limit && r.top >= top) return;
  if (sc) sc.scrollTop += r.bottom > limit ? r.bottom - limit : r.top - top;
}
